import { button, icon } from "../../tokens/component";
import { state } from "../../tokens/semantic";

const MuiFab = {
    defaultProps: {
        size: 'large',
        color: 'success',
        disableFocusRipple: true,
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            borderRadius: button.size.radius.icon,
            '&:focus-visible': {
                outline: `${state.outline.weight.focus.md} solid ${state.outline.color.focus}`,
                outlineOffset: state.outline.offset.focus.md,
                boxShadow: 'inherit'
            },
            '&.Mui-disabled': {
                opacity: state.opacity.disabled,
            },
        },
        sizeSmall: {
            width: button.size.sm,
            height: button.size.sm,
            '& svg': {
                fontSize: icon.size.xs,
            }
        },
        sizeMedium: {
            width: button.size.md,
            height: button.size.md,
            '& svg': {
                fontSize: icon.size.sm,
            }
        },
        sizeLarge: {
            width: button.size.lg,
            height: button.size.lg,
            '& svg': {
                fontSize: icon.size.md,
            }
        },
        primary: {
            backgroundColor: button.color.filled.bg.primary.default,
            boxShadow: button.effects.shadow.primary.floating,
            '&:hover': {
                backgroundColor: button.color.filled.bg.primary.hover,
            },
            '&:active': {
                backgroundColor: button.color.filled.bg.primary.active,
            },
            '&.Mui-disabled': {
                backgroundColor: button.color.filled.bg.primary.default,
                color: button.color.filled.content.default
            }
        },
        secondary: {
            backgroundColor: button.color.filled.bg.secondary.default,
            color: button.color.filled.content.secondary,
            boxShadow: button.effects.shadow.secondary.floating,
            border: `1px solid ${button.color.filled.border.secondary}`,
            '&:hover': {
                backgroundColor: button.color.filled.bg.secondary.hover,
            },
            '&:active': {
                backgroundColor: button.color.filled.bg.secondary.active,
            },
            '&.Mui-disabled': {
                backgroundColor: button.color.filled.bg.secondary.disabled,
                color: button.color.filled.content.secondary
            }
        },
        success: {
            backgroundColor: button.color.filled.bg.accent.default,
            boxShadow: button.effects.shadow.accent.floating,
            '&:hover': {
                backgroundColor: button.color.filled.bg.accent.hover,
            },
            '&:active': {
                backgroundColor: button.color.filled.bg.accent.active,
            },
            '&.Mui-disabled': {
                backgroundColor: button.color.filled.bg.accent.default,
                color: button.color.filled.content.default
            }
        }
    }
}

export default MuiFab;  